/**
 * Defends against open-redirect: only same-origin paths starting with a
 * single `/` are honoured. Protocol-relative `//host` strings are still
 * browser-followable so they're rejected too. Anything else (full URLs,
 * relative paths, null) collapses to null — the caller picks a safe
 * default destination.
 */
export function safeRedirectPath(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (!raw.startsWith("/")) return null;
  if (raw.startsWith("//")) return null;
  return raw;
}
